const api = {
  login: '/user/auth',
  ajaxDelete: '/design/question/ajaxDelete',
  deleteSurvey: '/design/my-survey/delete',
  getSurveyWithAnswer: '/survey-answer',
  saveAnswerList: '/survey-answer/save',
  addLogicBefor: '/design/question/addLogicBefor',
  addLogic: '/design/question/addLogic',
  deleteLogicBefor: '/design/question/deleteLogicBefor',
  deleteLogic: '/design/question/deleteLogic',
  deleteAllLogic: '/design/question/deleteAllLogic',
  getSurveyInfoById: '/design/my-survey-design/getSurveyById',
  getSurveyInfo: '/design/my-survey-design/getSurveryByQuestionId',
  mntSurveyInfo: '/design/my-survey-design/saveSurvey',
  updateQuestionOrderById: '/design/my-survey-design/updateQuestionOrderById',
  answerProcess: '/survey-answer/answerProcess',
  nextPage: '/survey-answer/nextPage',
  getQuestionList: '/design/my-survey-design/getQuestionList',
  getLanguage: '/design/language/getLanguage',
  getLanguageList: '/design/language/list',
  getLanguageByType: '/design/language/getLanguageByType',
  saveLanguage: '/design/language/saveLanguage',
  getStyleById: '/survey/getStyleById',
  saveStyle: '/survey/saveStyle',
  answerTD: '/survey/answerTD',
  queryProjectList: '/design/my-survey/list',
  getSelectList: '/system/dict/data/typedata/sys_location',
  downShortUrl: '/survey/downShortUrl',
  saveParam: '/surveryparam/saveParam',
  getParam: '/surveryparam/getParam',
  delParam: '/surveryparam/delParam',
  surveylist: '/design/my-survey/surveylist',
  getSurveyCode: '/survey-code/getSurveyCode',
  getSurveySubCode: '/survey-code/getSurveySubCode',
  addLogicBeforGroup: '/design/question/addLogicBeforGroup',
  deleteLogicBeforGroup: '/design/question/deleteLogicBeforGroup',
  saveSurveyStatus: '/survey/saveSurveyStatus',
  addLogicAnswerRule: '/design/question/addLogicAnswerRule',
  deleteLogicAnswerRule: '/design/question/deleteLogicAnswerRule',
  copySurvey: '/design/my-survey-design/copySurvey',
  uploadWxImage: '/up/uploadWxImage',
  uploadWxAudio: '/up/uploadWxAudio',
  sendPhoneCode: '/user/auth/sendPhoneCode', // 发送验证码
  sendEmailCode: '/user/auth/sendEmailCode',
  getRedEnvActivityUrl: '/survey-activities/url'
}
export default api



// WEBPACK FOOTER //
// ./src/config/api.js